import { Typography } from '@mui/material';
import { AppDivider } from 'components/core/AppDivider/AppDivider';
import Grid from 'components/core/Grid';
import LoadingSkeleton from 'components/core/LoadingSkeleton/LoadingSkeleton';
import { CheckoutSectionTitle } from 'components/views/pages/Checkout/components/CheckoutSectionTitle';
import { BookingCheckoutResponse } from 'components/views/pages/Checkout/hooks/useCheckout';

interface Props {
  checkoutData: BookingCheckoutResponse | undefined;
}

export const CheckoutDamageDepositSecurity = ({ checkoutData }: Props) => {
  const isLoading = !checkoutData;

  const description = checkoutData?.BOOKING.PROPERTY.DAMAGE_DEPOSIT.DESCRIPTION;

  return (
    <Grid item xs={12}>
      <AppDivider marginVertical="24px" />
      <CheckoutSectionTitle>Damage Deposit/Security</CheckoutSectionTitle>
      <LoadingSkeleton isLoading={isLoading}>
        <Typography variant="body1">{description}</Typography>
      </LoadingSkeleton>
    </Grid>
  );
};
